<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Administration des concerts
            </h1>
        </section>

        <!-- Main content -->
        <section class="content">
            <header>
                <router-link class="btn btn-primary" :to="{ name : 'concerts.create' }">
                    <i class="fa fa-plus"></i> Créer un nouveau concert
                </router-link>
            </header>

            <!-- Default box -->
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Liste des concerts</h3>
                </div>
                <div class="box-body table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th>N°</th>
                            <th>Date</th>
                            <th>Intitulé</th>
                            <th>Lieu</th>
                            <th>Clôturé O/N ?</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="concert in concerts">
                            <td>{{ concert.id }}</td>
                            <td>{{ concert.event_day }}</td>
                            <td>{{ concert.name }}</td>
                            <td>{{ concert.address }}, {{ concert.city }}</td>
                            <td>{{ new Date(concert.event_day).getTime() < new Date().getTime() ? 'OUI' : 'NON' }}</td>
                            <td>
                                <router-link :to="{ name: 'concerts.edit', params: { id: concert.id }}">Editer</router-link>
                                /<router-link :to="{ name: 'concerts.show', params: { id: concert.id }}">Voir</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">

                </div>
                <!-- /.box-footer-->
            </div>
            <!-- /.box -->

        </section>
        <!-- /.content -->
    </div>
</template>

<style>
    .content header {
        margin: 0.5em 0;
    }
</style>

<script>
  export default {
    name: 'DashboardIndex',
    data: function () {
      return {
        'concerts': []
      }
    },
    created: function () {
      this.$http.get('http://ws.ojssymphonique.net/api/concerts?token=' + localStorage.getItem('token')).then(function (data) {
        this.concerts = data.body
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?59e8c10c